import React from 'react';
import { ColumnType } from '@base/ui/components/dataTable';
import { Transaction } from '@base/features/user/model/interfaces';

export const accountStatementColumns: ColumnType<Transaction>[] = [
  {
    title: 'type',
    dataIndex: 'transactionType',
    render: (feeStats) => <span>{feeStats.transactionType}</span>,
  },
  {
    title: 'date',
    dataIndex: 'date',
    render: (feeStats) => <span>{feeStats.date}</span>,
  },
  {
    title: 'time',
    dataIndex: 'time',
    render: (feeStats) => <span>{feeStats.time}</span>,
  },
  {
    title: 'tickets',
    dataIndex: 'tickets',
    render: (feeStats) => <span>{feeStats.tickets}</span>,
  },
  {
    title: 'balance',
    dataIndex: 'balance',
    render: (feeStats) => <span>{feeStats.balance}</span>,
  },
];
